var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex fill-height justify-center align-center flex-column"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"indigo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }